<script>
  import { format } from 'svelte-i18n';
  import { Alert } from '@sveltestrap/sveltestrap';

  import { Icon } from '@client/components/icon';

  export let errors = [];
  export let headers = [];
  export let rows = [];
  export let isFilter = false;

  $: hasHeader = headers.includes('username');
</script>

{#if errors.length}
  <div {...$$restProps}>
    <Alert color="danger" class="text-danger py-2">
      <Icon name="alert-triangle" />
      {$format('label.SYNC_CSV_ERROR')}
    </Alert>
  </div>
{:else if !hasHeader}
  <div {...$$restProps}>
    <Alert color="danger" class="text-danger py-2">
      <Icon name="alert-triangle" />
      {@html $format('label.SYNC_CSV_USERNAME')}
    </Alert>
  </div>
{:else if headers.length && rows.length}
  <div {...$$restProps}>
    <Alert color="success" class="text-success py-2">
      <Icon name="check-circle" />
      {#if isFilter}
        {$format('label.CSV_FILTER_READY', { values: { users: rows.length, fields: headers.length } })}
      {:else}
        {$format('label.SYNC_READY', { values: { users: rows.length, fields: headers.length } })}
      {/if}
    </Alert>
  </div>
{/if}
